import { Button, Grid } from '@mui/material'
import React from 'react'
import { Size } from '../../hooks/useModal'

interface RestockOrderButtonBarProps {
  onClickCreateInventoryCheck: (psize?: Size) => void
}

export const RestockOrderButtonBar: React.FC<RestockOrderButtonBarProps> = ({
  onClickCreateInventoryCheck
}) => {
  return (
    <Grid container justifyContent='flex-end' spacing={2}>
      <Grid container item xs={12} md={8} spacing={3} justifyContent='flex-end'>
        <Grid
          item
          xs={12}
          lg={3}
          justifyContent='flex-end'
          alignContent='flex-end'
          alignItems='flex-end'
        >
          <Button
            fullWidth
            variant='contained'
            color='primary'
            size='small'
            onClick={() => onClickCreateInventoryCheck('md')}
          >
            Crear Orden
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
